import { SVGProps, Ref, forwardRef } from "react";

const ReverseRightIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 16 16"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Reverse Right Icon"
    {...props}
  >
    <title id="Reverse Right Icon">Reverse Right Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.667}
      d="M14.667 4.833H6.333a5 5 0 0 0 0 10h8.334m0-10L11.333 1.5m3.334 3.333-3.334 3.334"
    />
  </svg>
);

const ForwardRef = forwardRef(ReverseRightIcon);
export default ForwardRef;
